import type { IFallBackTranslations } from '@/Templates/FallBack/Types/translations';

const enUS: IFallBackTranslations = {
  notFound: {
    title: 'Oops!',
    subtitle: 'Page not found',
    description: 'It looks like you were detached from our AIoT world...',
    button: 'Back to home',
  },
  maintanance: {
    title: "We're back!",
    subtitle: 'We are making some adjustments',
    description:
      "We're improving your experience. Things will be even better soon! You can refresh the page or come back later.",
  },
  instability: {
    title: 'Hold on!',
    subtitle: 'We are experiencing some instability',
    description:
      'Our system is experiencing temporary instability. We are working to restore full functionality. Please try again in a few moments.',
  },
};

export { enUS };
